export const LOAD_COURSE_LIST   = 'LOAD_COURSE_LIST'
export const COURSE_LIST_FAIL   = 'COURSE_LIST_FAIL'

export const LOAD_COURSE_DETAIL   = 'LOAD_COURSE_DETAIL'
export const COURSE_DETAIL_FAIL   = 'COURSE_DETAIL_FAIL'

